import router from '@/router'
import omit from 'lodash/omit'

/**
 * Gets query value from router, for given key
 *
 * @param {*} query Query key
 * @returns Query value or false if query is not defined
 */
export function getQuery(query) {
    const querys = router.currentRoute.query
    return querys && querys[query] ? querys[query] : false
}

/**
 * Sets new query object for current route
 *
 * @param {*} queryObject New query object
 * @returns
 */
export function setQuery(queryObject) {
    let querys = router.currentRoute.query
    const currentURL = router.currentRoute.path
    let newQuerys = JSON.parse(JSON.stringify(querys))
    Object.keys(queryObject).forEach(key => {
        if (queryObject[key]) {
            newQuerys[key] = queryObject[key].toString()
        }
    })
    return router
        .replace({ path: currentURL, query: newQuerys })
        .catch(() => {})
}

/**
 * Removes query with given key in current route.
 *
 * @param {*} query_key
 * @returns
 */
export async function removeQuery(query_key) {
    if (!query_key) return
    const currentURL = router.currentRoute.path
    const { query } = router.currentRoute
    const newQuery = omit(
        { ...query },
        Array.isArray(query_key) ? query_key : [query_key]
    )
    return router.replace({ path: currentURL, query: newQuery }).catch(() => {})
}

/**
 * Gets parameter value from router, by given key
 *
 * @param {*} param Parameter key
 * @returns Parameter value or empty object, if parameters is not defined
 */
export function getParam(param) {
    const params = router.currentRoute.params
    return params && params[param] ? params[param] : {}
}
